import {BaseService} from "./BaseService";
import {AxiosResponse} from "axios";
import ApiResponse from "../Models/ApiResponse";
import api from "../Interceptors/Interceptor";
import {IDashboardMenuItemModel} from "./DashboardService";

export interface ICrudCustomerModel {
    uuid: string
    name?: string
    style?: string
    applicationUrl?: string
    totalUsers?: number
    totalPermissions?: number
    active?: boolean
}

export interface ICustomerModel {
    uuid: string
    name: string
    style: string
    applicationUrl: string
    totalUsers: number
    totalPermissions: number
    active: boolean
}


export interface IBrowserBrandingModel {
    browserTitle?: string | null;
    favicon?: string | null;
    subCustomer?: boolean;
}

export interface CustomerStylingModel {
    uuid: string;
    applicationBackgroundColor: string;
    applicationBackgroundColorText: string;
    applicationBackgroundImage: string;
    primaryColor: string;
    primaryColorText: string;
    primaryHoverColor: string;
    primaryInputBackgroundColor: string;
    primaryInputTextColor: string;
    secondaryColor: string;
    secondaryColorText: string;
    secondaryHoverColor: string;
    secondaryInputBackgroundColor: string;
    secondaryInputTextColor: string;
    tertiaryColor: string;
    tertiaryColorText: string;
    tertiaryHoverColor: string;
    tertiaryInputBackgroundColor: string;
    tertiaryInputTextColor: string;
    firstChartColor: string;
    secondChartColor: string;
    thirdChartColor: string;
    fourthChartColor: string;
    fifthChartColor: string;
    goodColor: string;
    mdrtColor: string;
    wrnColor: string;
    rskyColor: string;
    errorColor: string;
    ovrtrgColor: string;
}

export class CustomerStyleService extends BaseService<ICustomerModel, ICrudCustomerModel> {

    public async fetchDefault(): Promise<AxiosResponse<ApiResponse<CustomerStylingModel>>> {
        return await api.get(`v1/${this.modelUrl()}/default`, {});
    }

	public async fetchUrlSpecificStyling(): Promise<AxiosResponse<ApiResponse<string>>> {
		return await api.get(`v1/${this.modelUrl()}/url-specific`, {});
	}

	public async fetchUrlSpecificBranding(): Promise<AxiosResponse<ApiResponse<IBrowserBrandingModel>>> {
		return await api.get(`v1/${this.modelUrl()}/url-specific-branding`, {
			params: { origin: window.location.origin },
		});
	}

	public async fetchSessionBranding(): Promise<AxiosResponse<ApiResponse<IBrowserBrandingModel>>> {
		return await api.get(`v1/${this.modelUrl()}/session-branding`, {});
	}

    protected modelUrl(): string {
        return "security-customer-style";
    }
}